// extracted by mini-css-extract-plugin
module.exports = {"apiTokenContainer":"ApiTokens_apiTokenContainer__2Dz_h","warningText":"ApiTokens_warningText__37QQI","textArea":"ApiTokens_textArea__1RydT"};